import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from "@mui/material";

import MobileSectionTitle from './MobileSectionTitle';
import { Box, Typography, Stack } from "../../../imports/muiImport";
import {  NavLink, titleToUrl, useNavigate } from '../../../imports/generalImport';


const MobileHotDealsCard = ({ data }) => {
    const redirectLink = `/card-details/${data?.id}/${titleToUrl(data?.title)}`;
    const navigate = useNavigate();

    return (
        <Box
            component={"div"}
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                columnGap: 1.5,
            }}
        >

            <NavLink
                to={redirectLink}
                style={{
                    textDecoration: "none",
                }}
            >
                <Box
                    component={"img"}
                    src={data?.bestseller}
                    alt={data?.title}
                    sx={{
                        width: 85,
                        height: "auto",
                        borderRadius: 2,
                    }}
                />
            </NavLink>

            <Box
                component={"div"}
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 90px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flex: 1,
                }}
            >
                <Box
                    component={"div"}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start"
                    }}
                >
                    <NavLink
                        to={redirectLink}
                        style={{
                            textDecoration: "none",
                        }}
                    >
                        <Typography
                            variant='subtitle1'
                            sx={{
                                textTransform: "capitalize",
                                fontSize: "1.250rem",
                                color: "dark.main",
                                lineHeight: 1.225,
                                mb: 0.5
                            }}
                        >
                            {data?.title}
                        </Typography>

                        <Typography
                            variant='subtitle2'
                            component={"div"}
                            sx={{
                                textTransform: "capitalize",
                                fontSize: "1.350rem",
                                color: "dark.main"
                            }}
                        >
                            Save
                            <Typography
                                variant='subtitle2'
                                component={"span"}
                                sx={{
                                    ml: 0.5,
                                    textTransform: "capitalize",
                                    fontSize: "1.325rem",
                                    color: "green.main"
                                }}
                            >
                                {data?.discount}%
                            </Typography>
                        </Typography>
                    </NavLink>
                </Box>

                <Button
                    variant='contained'
                    onClick={() => navigate(redirectLink, { replace: true })}
                    sx={{
                        color: "dark.main",
                        textTransform: "capitalize",
                        fontSize: "1.425rem",
                        backgroundColor: "white.light",
                        borderRadius: 6,
                        boxShadow: 0,
                        px: 3,

                        "&:hover": {
                            color: "dark.main",
                            backgroundColor: "secondary.light",
                            boxShadow:3
                        }
                    }}
                >
                    Buy
                </Button>
            </Box>


        </Box>
    )
}


const MobileHotDeals = (props) => {
    const { title, products, redirectLink } = props;
    const [productLoading, setProductionLoading] = useState(false);

    useEffect(() => {
        setProductionLoading(true);
        if (products?.length > 0) {
            setProductionLoading(false);
        }
    }, [products?.length]);


    if (productLoading) {
        return (
            <Box sx={{
                minHeight: "30vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            component={"div"}
            sx={{
                my: 3,
                px: 1,
                pb: 1.5,
                backgroundColor: "white.main",
            }}
        >
            {title && (
                <Stack sx={{
                    mb: 1,
                }}>
                    <MobileSectionTitle
                        sectionTitle={title}
                        buttonText={null}
                        redirectLink={redirectLink}
                    />
                </Stack>
            )}

            <Box
                component={"div"}
                sx={{
                    display: "grid",
                    gridTemplateRows: "repeat(1, 1fr)",
                    rowGap: 2,
                    // overflowY: "auto",
                }}
            >
                {products?.map((item) => <MobileHotDealsCard key={`hot-deal-card-${item?.id}`} data={item} />)}
            </Box>
        </Box>
    )
}

export default MobileHotDeals;
